// utils/localStorageUtils.js

// Função para salvar um objeto no localStorage
export const saveToLocalStorage = (key, data) => {
    try {
      const serializedData = JSON.stringify(data);
      localStorage.setItem(key, serializedData);
    } catch (error) {
      console.error('Erro ao salvar no localStorage:', error);
    }
  };
  
  // Função para recuperar um objeto do localStorage
  export const loadFromLocalStorage = (key) => {
    try {
      const serializedData = localStorage.getItem(key);
      return JSON.parse(serializedData);
    } catch (error) {
      console.error('Erro ao carregar do localStorage:', error);
      return null;
    }
  };
  // Função para recuperar um objeto do localStorage
  export const loadItemFromLocalStorage = (key) => {
    console.clear();
    console.log("okokok",key);
    try {
      console.log("localStorage.getItem(key)",localStorage.getItem(key));
      return localStorage.getItem(key);      
    } catch (error) {
      console.error('Erro ao carregar do localStorage:', error);
      return null;
    }
  };
  
  // Função para remover um objeto do localStorage
  export const removeFromLocalStorage = (key) => {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error('Erro ao remover do localStorage:', error);
    }
  };
  